import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema } from './config';


const EditDiscount = () => {
  return (
    <EditForm title={"Adjustment"} initialValues={initialValues} fields={fields} schema={schema} url={"adjustments"}>
      
     </EditForm>
  );
}

export default EditDiscount;